import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Col, Row , Label, Input} from 'reactstrap';
import api from '../../api';
import utils from '../../resources/utils';
import './index.css';

const dashboardFields = [
    'code_name',
    'name',
    'description',
    'iframe_code',
    'tag_text',
];

export default class DashboardScreen extends React.Component {
    constructor(props) {
        super(props);
        const queries = utils.parseQueryParams(this.props);

        let initialId = 0;
        if (this.props.match.params.dashboard_id) {
            initialId = this.props.match.params.dashboard_id;
        }
        this.state = {
            dashboard: {
                id: parseInt(initialId, 10) || '',
                code_name: '',
                description: '',
                name: '',
            },
        }
    }
    componentWillMount() {
        this.getDashboard();
    }
    componentDidMount = () => {
    }
    updateObjectAttributes(attr, value) {
        const { dashboard } = this.state;
        dashboard[attr] = value;
        this.setState({ dashboard });
    }
    getDashboard() {
        const { dashboard } = this.state;
        // Only in edit mode, should we load current data
        if (dashboard.id) {
            let uri = `dashboard/${dashboard.id}`;
            api.fetchAPI({
                method: 'get',
                uri,
                success: (response) => {
                    const dashboard = response.dashboard;
                    this.setState({ dashboard });
                },
                error: (error) => {
                console.error(error);
                }
            });
        }
    }
    updateDashboard() {
        const { dashboard } = this.state;
        let uri = `dashboards`;
        if (!dashboard.id) {
            // on create new dashboard, do not include id field
            delete dashboard.id;
        }
        api.fetchAPI({
            method: dashboard.id ? 'put' : 'post', // If no id is defined, which mean we will create a new one
            uri,
            body: dashboard,
            success: (response) => {
                if (response.status === 'ok') {
                    this.setState({ dashboard: response.dashboard }, () => {
                        this.props.history.push(`/dashboard/${response.dashboard.id}`);
                    });
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { dashboard } = this.state;
        document.title = `${dashboard.code_name || dashboard.name} | DataDex`;
        if (!dashboard) return null
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h1>Edit {dashboard.code_name}</h1>
                    </Col>
                </Row>
                <Row>
                    {dashboardFields.map(field => 
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{field}</Label>
                                <Input
                                    type="textarea"
                                    value={dashboard[field]}
                                    onChange={(e) => this.updateObjectAttributes(field, e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    )}
                    <Col xs={12}>
                        <FormGroup>
                            <Button onClick={() => this.updateDashboard()} color="success">
                                Save
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/DashboardEdit/index.js